import React from 'react'
import PropTypes from 'prop-types'

import createButtonContainer from './buttonContainer'

class NavButton extends React.Component {
  constructor(props) {
    super(props)
    this.onClick = this.onClick.bind(this)
    this.onKeyDown = this.onKeyDown.bind(this)
  }

  componentDidMount() {
    window.addEventListener('keydown', this.onKeyDown)
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyDown)
  }

  onClick(event) {
    const { selectItem, itemId } = this.props

    event.preventDefault()
    selectItem(itemId)
  }

  onKeyDown(event) {
    const { itemId, keyName } = this.props

    if (event.key === keyName && itemId) this.onClick(event)
  }

  render() {
    if (!this.props.itemId) return null

    return (
      <div onClick={this.onClick} className={this.props.className}>
        {this.props.children}
      </div>
    )
  }
}

NavButton.propTypes = {
  children: PropTypes.element.isRequired,
  selectItem: PropTypes.func.isRequired,
  itemId: PropTypes.number,
  keyName: PropTypes.string,
  className: PropTypes.string
}

export default createButtonContainer(NavButton)
